// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"37":"051c3541e017220cfadd","76":"7390dddc2802d42777da"}[chunkId] + ".chunk.js";
};